import { Auth } from "components/Parts/Organisms/Auth";
import { ReportFilePage } from "components/Parts/Organisms/ReportFilePage";
import React from "react";

export const ReportFile = React.memo(() => (
  <Auth>
    <ReportFilePage />
  </Auth>
));
